import React, { Component } from "react"
import { Link } from "react-router"
import { translate } from "translate"
import { Row, Spinner, Form, FormField, Checkbox, Col, Button } from "elemental"
import { browserHistory } from "react-router"
import "./CheckoutPage.scss"

import shop from "../../shop/shop"
import CartMini from "../../components/Cart/CartMini"

class ConfirmationPage extends Component {
  constructor() {
    super()
    this.state = {
      show:    false,
      cart:    shop.cart,
      agb:     false,
      loading: false,
    }
    shop.cart.hooks.changed.add( this.update )
  }

  update = ( cart ) => {
    this.setState( { cart } )
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.update )
  }

  handleSubmit = () => {
    this.setState( { loading: true } )
    shop.cart.post( {
      extras: {
        delivery_address_id: shop.cart.data.deliveraddress.mapid,
        manual_order_id:     false
      }
    } )
      .then( () => {
        browserHistory.push( "/checkout/success" )
      } )
  }

  handleAgb = ( agb ) => {
    console.log( `agb`, agb )
    this.setState( { agb } )
  }

  toHome = () => {
    browserHistory.push( "/home" )
  }

  render() {
    let { agb, loading } = this.state
    let { comment, deliveraddress } = shop.cart.data
    let billingAddress = null
    let hasSession = !!shop.hasSession()

    if ( hasSession ) {
      let session = shop.hasSession()
      billingAddress = session.value


      if ( !billingAddress ) billingAddress = {}
      if ( !deliveraddress ) deliveraddress = session.value
      console.log( shop.cart.data )
    }
    return (
      <div>
        <section className="mb0">
          <Row className="top-bar tc">
            <Col sm="1/3"><Link to={"/checkout"}>1. {translate( "cart.cart" )} </Link></Col>
            <Col sm="1/3"><Link to={"/checkout/delivery"}>2. {translate( "cart.address" )}</Link></Col>
            <Col sm="1/3"><Link to={"/checkout/confirmation"}><strong>3. {translate( "cart.check_and_submit" )}</strong></Link></Col>
          </Row>
        </section>

        <div className="container pa4">
          <h2>{translate( "shop.check_and_confirm" )}</h2>

          <Row>
            <Col lg="1/2" className="br b--black-05">
              <div className="pa4">
                <h3>Warenkorb</h3>
                <CartMini interactive={false}/>
              </div>
            </Col>

            <Col lg="1/2">
              <div className="pa4">
                <h3>{translate( "address.delivery_address" )}</h3>
                <div className="mb4">
                  {deliveraddress.company}<br/>
                  {deliveraddress.title} {deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}<br/>
                  {deliveraddress.street} <br/>
                  {deliveraddress.addition} <br/>
                  {deliveraddress.pcode} {deliveraddress.city}<br/>
                  {deliveraddress.country}<br/>
                </div>

                <h3>{translate( "address.invoice" )}</h3>
                <div className="mb4">
                  {billingAddress.title} <br/>
                  {billingAddress.street} <br/>
                  {billingAddress.pcode} {billingAddress.city}<br/>
                  {billingAddress.country}<br/>
                </div>

                <h3>{translate( "shop.AGB_DELIVERY_INFO" )}</h3>
                <div className="mb4">
                  <Form type="horizontal">
                    <FormField>
                      <Checkbox value={agb} onChange={( e ) => this.handleAgb( e.target.checked )}
                                label={translate( "shop.CONFIRM_AGB_DELIVERY_INFO" )}/>
                    </FormField>
                  </Form>
                </div>

                <h3>{translate( "cart.your_comment" )}:</h3>
                <p className="mb4">{comment ? comment : "-"}</p>

                <Button
                  disabled={!agb || loading}
                  type="primary"
                  onClick={this.handleSubmit}
                  style={{
                    paddingLeft:  "32px",
                    paddingRight: "32px"
                  }}>{!loading ? <span>{translate( "shop.finalize_order" )}</span> : <Spinner type="primary"/>}</Button>
              </div>

            </Col>
          </Row>
        </div>

        <section className="pa2 mb4 bg-silver">
          <div className="container">
            <Row>
              <Col sm="1/1"
                   className="tl">
                <Link to="/checkout/delivery"> <Button type="link"> <i className="icon-angle-left"/> Zurück </Button></Link>
              </Col>
            </Row>
          </div>
        </section>
      </div>

    )
  }
}

export default ConfirmationPage



// WEBPACK FOOTER //
// ./src/pages/checkout/ConfirmationPage.js